import u from 'umbrellajs/umbrella.esm.js';

export function initAlerts() {
  u('.bsk-alert-close').on('click', function () {
    u(this.closest('.bsk-alert')).addClass('hidden');
  });
}